export default "__VITE_ASSET__C5sS9K2e__"